// プレイヤー選択における選択したプレイヤーの追加を行う
$(document).on('turbolinks:load', function () {

  // プレイヤー選択モーダルコンポーネント
  const playerSelectModal = window.PlayerSelectModal ? new window.PlayerSelectModal() : null;

  if (window.location.pathname.includes('/players/new')) {
    const league = gon.league; // リーグ戦のプレイヤー初期選択 or 編集で設定
    const leaguePlayerEdit = gon.leaguePlayerEdit; // リーグプレイヤー編集で設定
    const $selectedPlayersContainer = $('.selected_players');
    const $bulkPlayerAdd = $('.bulk-player-add');
    let selectedPlayers = [];
    let clientKeySequence = 0;
    let bulkPreviewRows = [];

    function nextClientKey() {
      clientKeySequence += 1;
      return `new-${Date.now()}-${clientKeySequence}`;
    }

    function normalizeStoredPlayer(player) {
      if (Array.isArray(player)) {
        return {
          id: Number(player[0]),
          name: String(player[1] || ''),
          clientKey: player[2] || nextClientKey()
        };
      }

      return {
        id: Number(player.id),
        name: String(player.name || ''),
        clientKey: player.clientKey || nextClientKey()
      };
    }

    function loadStoredPlayers() {
      if (leaguePlayerEdit) return [];

      const storedPlayers = sessionStorage.getItem('selected_players');
      if (!storedPlayers) return [];

      try {
        const parsedPlayers = JSON.parse(storedPlayers);
        return Array.isArray(parsedPlayers) ? parsedPlayers.map(normalizeStoredPlayer) : [];
      } catch (error) {
        console.warn('Failed to restore selected players:', error);
        sessionStorage.removeItem('selected_players');
        return [];
      }
    }

    function selectedPlayerName($item) {
      return $item.find('.selected_players-item__name').text() || $item.find('span').first().text();
    }

    function assignClientKey($item, playerId) {
      const currentKey = $item.attr('data-client-key');
      if (currentKey) return currentKey;

      const clientKey = playerId > 0 ? `player-${playerId}` : nextClientKey();
      $item.attr('data-client-key', clientKey);
      return clientKey;
    }

    function syncSelectedPlayersFromDom() {
      selectedPlayers = [];
      $('.selected_players-item').each(function () {
        const $item = $(this);
        const id = Number($item.find('.p_id').text());
        selectedPlayers.push({
          id: id,
          name: selectedPlayerName($item),
          clientKey: assignClientKey($item, id)
        });
      });
    }

    function storeSelectedPlayers() {
      if (leaguePlayerEdit) {
        sessionStorage.removeItem('selected_players');
        return;
      }

      sessionStorage.setItem('selected_players', JSON.stringify(selectedPlayers));
    }

    function replacePlaceholders(template, replacements) {
      return Object.keys(replacements).reduce(function (text, key) {
        return text.split(`%{${key}}`).join(replacements[key]);
      }, template || '');
    }

    const bulkI18nData = $bulkPlayerAdd.data('i18n');
    const bulkI18n = typeof bulkI18nData === 'string'
      ? JSON.parse(bulkI18nData || '{}')
      : (bulkI18nData || {});
    const removePlayerText = $('#selected_players').data('remove-player-text') || bulkI18n.removePlayer || '';

    function createSelectedPlayerItem(player) {
      const $playerItem = $('<div>', {
        class: 'selected_players-item',
        'data-client-key': player.clientKey
      });
      const $playerName = $('<span>', { class: 'selected_players-item__name' }).text(player.name);
      const $deleteButton = $('<button>', {
        type: 'button',
        class: 'selected_players-item__delete player-delete-2',
        'aria-label': replacePlaceholders(removePlayerText, { name: player.name })
      });
      const $deleteIcon = $('<i>', {
        class: 'bx bx-trash',
        'aria-hidden': 'true'
      });
      const $playerId = $('<div>', { class: 'p_id', hidden: true }).text(player.id);

      $deleteButton.append($deleteIcon);
      $playerItem.append($playerName, $deleteButton, $playerId);
      return $playerItem;
    }

    syncSelectedPlayersFromDom();
    loadStoredPlayers().forEach(function (player) {
      const persistedPlayerExists = player.id > 0 && selectedPlayers.some(function (selectedPlayer) {
        return selectedPlayer.id === player.id;
      });
      if (persistedPlayerExists) return;

      $selectedPlayersContainer.append(createSelectedPlayerItem(player));
      selectedPlayers.push(player);
    });
    syncSelectedPlayersFromDom();
    storeSelectedPlayers();

    function updatePastPlayerSelection() {
      const selectedIds = selectedPlayers.map(function (selectedPlayer) {
        return selectedPlayer.id;
      });
      $('.players_list-item').each(function () {
        const playerId = Number($(this).find('.p_id').text());
        $(this).toggleClass('selected', selectedIds.includes(playerId));
      });
    }

    updatePastPlayerSelection();

    function updateCurrentPlayerButton() {
      const $button = $('#add-current-player-btn');
      if (!$button.length) return;

      const currentPlayerId = Number($button.data('player-id'));
      const alreadySelected = selectedPlayers.some(function (player) {
        return player.id === currentPlayerId;
      });
      $button.closest('.dotted-text-link-container').toggle(!alreadySelected);
    }

    updateCurrentPlayerButton();

    // プレイヤー選択数の上限下限を設定
    let playerCount = $('.player-num').text();
    let maxPlayers = Number(playerCount);
    // リーグ初回登録・通常対局とも、下限は対戦人数（三麻3・四麻4）
    const minPlayers = Number(getUrlParameterPlayType());

    updateSelectedCounter(); // 選択済みプレイヤー数を更新

    updateParams(); // セッション格納分のプレイヤー情報をparamsに追加
    updateCreateButtonActivation(); // 決定ボタン状態の初期設定をする

    // ==================== クリックイベント処理 ==================== //
    const $playerFormContainer = $('#selected_players');
    const limitReachedText = $playerFormContainer.data('limit-reached-text') || '';
    const nameRequiredText = $playerFormContainer.data('name-required-text') || '';
    const nameTooLongText = $playerFormContainer.data('name-too-long-text') || '';
    const selectFirstMatchPlayersText = $playerFormContainer.data('select-first-match-players-text') || '';

    function addPlayer(playerName, playerId) {
      const id = Number(playerId);
      const persistedPlayerExists = id > 0 && selectedPlayers.some(function (selectedPlayer) {
        return selectedPlayer.id === id;
      });
      if (persistedPlayerExists) return false;

      const player = { id: id, name: playerName, clientKey: nextClientKey() };
      selectedPlayers.push(player);
      $selectedPlayersContainer.append(createSelectedPlayerItem(player));
      return true;
    }

    function updateSelectionState() {
      syncSelectedPlayersFromDom();
      storeSelectedPlayers();
      updatePastPlayerSelection();
      updateCurrentPlayerButton();
      updateSelectedCounter();
      updateParams();
      updateCreateButtonActivation();
      renderBulkPreview();
    }

    // ⚫︎プレイヤーを選択肢から選択する処理
    $('#add-current-player-btn').on('click', function () {
      if ($('.selected_players-item').length >= maxPlayers) {
        alert(limitReachedText);
        return;
      }

      if (addPlayer($(this).data('player-name'), $(this).data('player-id'))) updateSelectionState();
    });

    $('.players_list-item').on('click', function () {
      const playerName = $(this).find('.p_name').text();
      const playerId = $(this).find('.p_id').text();

      // 選択プレイヤー上限数をチェック
      if ($(".selected_players-item").length >= maxPlayers) {
        // 選択制限に達した場合、エラーメッセージを表示
        alert(limitReachedText);
        return;
      }
      if (addPlayer(playerName, playerId)) updateSelectionState();

    });

    // ⚫︎プレイヤー新規作成処理
    $('#new-player-create-btn').on('click', function () {
      if ($(".selected_players-item").length >= maxPlayers) {
        // 人数制限に達した場合、エラーメッセージを表示
        alert(limitReachedText);
        return;
      }
      const newPlayerName = $('#new-player-form').val().trim(); // 前後の空白を削除
      if (newPlayerName === '') {
        // 入力が空白の場合はエラーメッセージを表示するか、処理を中断できます
        alert(nameRequiredText);
        return;
      }
      if (newPlayerName.length > 8) {
        alert(nameTooLongText);
        return;
      }

      // ボタンのアイコンをチェックマークに変更
      const $button = $(this);
      const $icon = $button.find('i');
      const originalIconClass = $icon.attr('class');
      $icon.removeClass().addClass('fas fa-check text-green');

      // ツールチップを表示
      $('#create-success-tooltip').addClass('show');

      addPlayer(newPlayerName, 0);
      updateSelectionState();
      $('#new-player-form').val(''); // inputを空にする

      // 3秒後にアイコンとツールチップを元に戻す
      setTimeout(function () {
        $icon.removeClass().addClass(originalIconClass);
        $('#create-success-tooltip').removeClass('show');
      }, 3000);
    });

    // ⚫︎プレイヤー選択解除処理 - 送信用IDとは別のクライアント内IDで1行だけ削除する
    $('.selected_players').on('click', '.player-delete-1, .player-delete-2', function () {
      const $playerItem = $(this).closest('.selected_players-item');
      const clientKey = $playerItem.attr('data-client-key');
      selectedPlayers = selectedPlayers.filter(function (selectedPlayer) {
        return selectedPlayer.clientKey !== clientKey;
      });
      $playerItem.remove();
      updateSelectionState();
    });

    // ⚫︎認証済みプレイヤーの確認 - ページ更新なしで、招待URLから認証したユーザーを参加プレイヤーに追加する
    // 参照: leagues/team_edit.js の #inviteCheck
    $('#player-form-check-authenticated-btn').on('click', function () {
      const $button = $(this);
      if ($button.prop('disabled')) return;
      const $result = $('#player-form-check-authenticated-result');
      function showResult(text) {
        $result.text(text).prop('hidden', false);
      }

      $button.prop('disabled', true);
      fetch($button.data('url'), {
        method: 'GET',
        headers: { 'Accept': 'application/json' },
        credentials: 'same-origin'
      })
        .then(function (res) {
          if (!res.ok) throw new Error(`HTTP ${res.status}`);
          return res.json();
        })
        .then(function (players) {
          let added = 0;
          let limitReached = false;
          (players || []).forEach(function (player) {
            if (selectedPlayers.some(function (selectedPlayer) { return selectedPlayer.id === player.id; })) return;
            if ($('.selected_players-item').length >= maxPlayers) {
              limitReached = true;
              return;
            }
            if (addPlayer(player.name, player.id)) added += 1;
          });

          if (added > 0) updateSelectionState();
          if (limitReached) {
            showResult(limitReachedText);
          } else if (added > 0) {
            showResult(window.Janreco.pluralize($button.data('added-text'), added));
          } else {
            showResult($button.data('none-text'));
          }
        })
        .catch(function (e) {
          console.error('認証確認に失敗:', e);
          showResult($button.data('failed-text'));
        })
        .finally(function () {
          $button.prop('disabled', false);
        });
    });

    // ⚫︎プレイヤー決定（submit時制御）: 選択人数がplay_typeより大きいならモーダルでplay_typeに絞って送信
    $('#player-select-confirm-btn').on('click', function (e) {
      const $form = $(this).closest('form').length ? $(this).closest('form') : $(this);
      const currentCount = $(".selected_players-item").length;

      if (!league && currentCount > minPlayers) {
        e.preventDefault();

        if (!playerSelectModal) return;
        // 現在の選択済みからモーダル用itemsを生成
        const items = [];
        $(".selected_players-item").each(function () {
          const pid = Number($(this).find('.p_id').text());
          const pname = $(this).find('span').first().text();
          items.push({ id: pid, name: pname });
        });
        playerSelectModal.open({
          items: items,
          limit: minPlayers,
          title: selectFirstMatchPlayersText,
          onConfirm: function (selectedIds, selectedNames) {
            // モーダル内で決定ボタンが押された場合の処理
            // hidden inputsを現在選択済みのプレイヤーで再構築する
            $form.find('input[name="p_ids[]"], input[name="p_names[]"], input[name="league_player"]').remove();
            appendHiddenInputs($form, selectedIds, selectedNames);
            sessionStorage.clear();
            // ネイティブsubmitで確実に送信
            $form.get(0).submit();
          }
        });
      } else {
        // そのまま送信
        sessionStorage.clear();
      }

    });

    // プレイヤー決定時に送信されるparamsを更新する
    function updateParams() {

      // 既存の自前hiddenだけ削除（CSRFトークン等は保持）
      $('#player-select-confirm-btn').find('input[name="p_ids[]"], input[name="p_names[]"], input[name="participant_ids[]"], input[name="participant_names[]"], input[name="league_player"]').remove();

      // minPlayers〜maxPlayers の範囲であれば #player-select-confirm-btn に params を追加
      const count = $('.selected_players-item').length;
      if ((count >= minPlayers && count <= maxPlayers) || (leaguePlayerEdit && count <= maxPlayers)) {

        const selectedPlayerNames = [];
        const selectedPlayerIds = [];

        // "selected_players-item" クラスを持つすべての要素をループ
        $(".selected_players-item").each(function () {
          const playerName = selectedPlayerName($(this));
          const playerId = $(this).find('.p_id').text();
          selectedPlayerNames.push(playerName);
          selectedPlayerIds.push(playerId);
        });

        for (let i = 0; i < selectedPlayerIds.length; i++) {
          const $hiddenInput = $('<input>', {
            type: 'hidden',
            name: 'p_ids[]',
            value: selectedPlayerIds[i],
            autocomplete: 'off'
          });
          $('#player-select-confirm-btn').append($hiddenInput);
        }

        for (let i = 0; i < selectedPlayerNames.length; i++) {
          const $hiddenInput = $('<input>', {
            type: 'hidden',
            name: 'p_names[]',
            value: selectedPlayerNames[i],
            autocomplete: 'off'
          });
          $('#player-select-confirm-btn').append($hiddenInput);
        }

        for (let i = 0; i < selectedPlayerIds.length; i++) {
          const $hiddenInput = $('<input>', {
            type: 'hidden',
            name: 'participant_ids[]',
            value: selectedPlayerIds[i],
            autocomplete: 'off'
          });
          $('#player-select-confirm-btn').append($hiddenInput);
        }

        for (let i = 0; i < selectedPlayerNames.length; i++) {
          const $hiddenInput = $('<input>', {
            type: 'hidden',
            name: 'participant_names[]',
            value: selectedPlayerNames[i],
            autocomplete: 'off'
          });
          $('#player-select-confirm-btn').append($hiddenInput);
        }

        // リーグプレイヤー編集モードの場合はparamsを追加
        if (leaguePlayerEdit) {
          const $hiddenInput = $('<input>', {
            type: 'hidden',
            name: 'league_player',
            value: 'edit',
            autocomplete: 'off'
          });
          $('#player-select-confirm-btn').append($hiddenInput);
        }

      }
    }

    // プレイヤー人数が min〜max の範囲であれば #player-select-confirm-btn をアクティブにする
    function updateCreateButtonActivation() {
      const count = $('.selected_players-item').length;
      if (count >= minPlayers && count <= maxPlayers) {
        $('#player-select-confirm-btn').prop('disabled', false).removeClass('inactive');
      } else {
        $('#player-select-confirm-btn').prop('disabled', true).addClass('inactive');
      }
    }

    // 選択済みプレイヤー数を更新する
    function updateSelectedCounter() {
      const selectedPlayerCount = $('.selected_players-item').length;
      $('.player-selected-count').text(selectedPlayerCount);
    }

    // URLパラメーター(play_type)を取得する
    function getUrlParameterPlayType() {
      const params = new URLSearchParams(window.location.search);
      return params.get(`play_type`);
    }

    // 選択済みDOMからid->nameマップを作る
    function appendHiddenInputs($form, selectedIds, selectedNames) {
      // DOM順に pids / pnames を配列化（重複pid対応）
      selectedIds.forEach((id) => {
        $form.append($('<input>', { type: 'hidden', name: 'p_ids[]', value: id, autocomplete: 'off' }));
      });
      selectedNames.forEach((name) => {
        $form.append($('<input>', { type: 'hidden', name: 'p_names[]', value: name, autocomplete: 'off' }));
      });
    }

    function bulkPlayerRows() {
      const inputNames = $('#bulk-player-names').val().split(/\r\n|\n/).map(function (line, index) {
        return { name: line.trim(), lineNumber: index + 1 };
      }).filter(function (line) {
        return line.name.length > 0;
      });
      const inputNameCounts = inputNames.reduce(function (counts, line) {
        counts.set(line.name, (counts.get(line.name) || 0) + 1);
        return counts;
      }, new Map());
      const selectedNames = new Set(selectedPlayers.map(function (player) {
        return player.name;
      }));
      const playedNames = new Set($('.players_list-item .p_name').map(function () {
        return $(this).text().trim();
      }).get());

      return inputNames.map(function (line) {
        const hasError = Array.from(line.name).length > 8;
        const duplicatePlayed = !hasError && playedNames.has(line.name);
        const hasWarning = !hasError && (
          inputNameCounts.get(line.name) > 1 ||
          selectedNames.has(line.name) ||
          duplicatePlayed
        );
        return {
          name: line.name,
          lineNumber: line.lineNumber,
          hasError: hasError,
          hasWarning: hasWarning,
          duplicatePlayed: duplicatePlayed
        };
      });
    }

    function previewStatus(row) {
      if (row.hasError) {
        return {
          modifier: 'error',
          label: bulkI18n.statusError,
          message: replacePlaceholders(bulkI18n.nameTooLong, { max: 8 })
        };
      }
      if (row.hasWarning) {
        return {
          modifier: 'warning',
          label: bulkI18n.statusWarning,
          // 過去対局プレイヤーとの同名だけは、成績が別人に紐づく点まで伝える
          message: row.duplicatePlayed ? bulkI18n.playedDuplicateWarning : bulkI18n.duplicateWarning
        };
      }
      // 正常行はラベルもメッセージも持たせない（例外だけを注釈して異常を見つけやすくする）
      return { modifier: 'valid' };
    }

    function createPreviewItem(row) {
      const status = previewStatus(row);
      const $item = $('<li>', { class: `bulk-player-add__preview-item is-${status.modifier}` });
      const $header = $('<div>', { class: 'bulk-player-add__preview-header' });
      const $main = $('<div>', { class: 'bulk-player-add__preview-main' });

      // 行番号は問題のある行だけに出す。正常行は名前だけを1行で並べる
      if (status.label) {
        $main.append($('<span>', { class: 'bulk-player-add__line-number' }).text(
          replacePlaceholders(bulkI18n.lineNumber, { number: row.lineNumber })
        ));
      }
      $main.append($('<span>', { class: 'bulk-player-add__preview-name' }).text(row.name));
      $header.append($main);
      if (status.label) {
        $header.append(
          $('<span>', { class: `bulk-player-add__status bulk-player-add__status--${status.modifier}` }).text(status.label)
        );
      }

      $item.append($header);
      if (status.message) {
        $item.append($('<span>', { class: 'bulk-player-add__preview-message' }).text(status.message));
      }
      return $item;
    }

    function renderBulkPreview() {
      if ($bulkPlayerAdd.length === 0) return;

      bulkPreviewRows = bulkPlayerRows();
      const errorCount = bulkPreviewRows.filter(function (row) { return row.hasError; }).length;
      const warningCount = bulkPreviewRows.filter(function (row) { return row.hasWarning; }).length;
      const selectedCount = $('.selected_players-item').length;
      const bulkMaxPlayers = Number($bulkPlayerAdd.data('max-player-num'));
      const capacityExceeded = selectedCount + bulkPreviewRows.length > bulkMaxPlayers;
      // 入力中の行も差し引いて残り枠を示す。超過分は下の上限エラーに任せ、表示は0で止める
      const remainingCount = Math.max(bulkMaxPlayers - selectedCount - bulkPreviewRows.length, 0);
      // エラー行は作成されないため、ボタンに出す人数からは除く
      const creatableCount = bulkPreviewRows.length - errorCount;
      const $preview = $bulkPlayerAdd.find('.js-bulk-player-preview');

      // 0件の項目は出さない。常時並んでいると1件出たときの変化に気づけないため
      $bulkPlayerAdd.find('.js-bulk-error-count')
        .text(replacePlaceholders(bulkI18n.errorCount, { count: errorCount }))
        .prop('hidden', errorCount === 0);
      $bulkPlayerAdd.find('.js-bulk-warning-count')
        .text(replacePlaceholders(bulkI18n.warningCount, { count: warningCount }))
        .prop('hidden', warningCount === 0);
      $bulkPlayerAdd.find('.js-bulk-remaining-count').text(
        remainingCount === 0
          ? bulkI18n.limitReached
          : replacePlaceholders(bulkI18n.remainingCount, { count: remainingCount })
      );
      $bulkPlayerAdd.find('.js-bulk-add-button-label').text(
        creatableCount === 0
          ? bulkI18n.addButton
          : replacePlaceholders(bulkI18n.addButtonWithCount, { count: creatableCount })
      );

      // 全消し再生成でプレビューのスクロール位置が先頭に戻らないようにする
      const previousScrollTop = $preview.scrollTop();
      $preview.empty();
      bulkPreviewRows.forEach(function (row) {
        $preview.append(createPreviewItem(row));
      });
      $preview.scrollTop(previousScrollTop);

      const $capacityError = $bulkPlayerAdd.find('.js-bulk-capacity-error');
      const capacityMessage = capacityExceeded
        ? replacePlaceholders(bulkI18n.capacityExceeded, {
          selected: selectedCount,
          input: bulkPreviewRows.length,
          max: bulkMaxPlayers
        })
        : '';
      // 内容が変わったときだけ書き換える（role="alert"が打鍵ごとに再読み上げされるのを防ぐ）
      if ($capacityError.text() !== capacityMessage) {
        $capacityError.text(capacityMessage).prop('hidden', capacityMessage === '');
      }

      $bulkPlayerAdd.find('.js-bulk-player-add-submit').prop(
        'disabled',
        bulkPreviewRows.length === 0 || errorCount > 0 || capacityExceeded
      );
    }

    $bulkPlayerAdd.off('click.bulkPlayerAddToggle', '.js-bulk-player-add-toggle')
      .on('click.bulkPlayerAddToggle', '.js-bulk-player-add-toggle', function () {
        const $toggle = $(this);
        const $panel = $bulkPlayerAdd.find('#bulk-player-add-panel');
        const isExpanded = $toggle.attr('aria-expanded') === 'true';
        const $closeText = $toggle.find('.toggle-close');
        $toggle.attr('aria-expanded', String(!isExpanded)).toggleClass('active', !isExpanded);
        $panel.prop('hidden', isExpanded);
        if (isExpanded) {
          $closeText.stop(true, true).slideUp(200);
        } else {
          $closeText.stop(true, true).slideDown(200);
        }
      });
    $bulkPlayerAdd.find('.js-bulk-player-add-toggle').prop('disabled', false).find('.toggle-close').hide();

    $bulkPlayerAdd.off('input.bulkPlayerAdd', '#bulk-player-names')
      .on('input.bulkPlayerAdd', '#bulk-player-names', function () {
        $bulkPlayerAdd.find('.js-bulk-added-notice').prop('hidden', true).text('');
        renderBulkPreview();
      });

    $bulkPlayerAdd.off('click.bulkPlayerAddSubmit', '.js-bulk-player-add-submit')
      .on('click.bulkPlayerAddSubmit', '.js-bulk-player-add-submit', function () {
        if ($(this).prop('disabled')) return;

        bulkPreviewRows.forEach(function (row) {
          addPlayer(row.name, 0);
        });
        const addedCount = bulkPreviewRows.length;
        $('#bulk-player-names').val('');
        updateSelectionState();
        $bulkPlayerAdd.find('.js-bulk-added-notice')
          .text(replacePlaceholders(bulkI18n.added, { count: addedCount }))
          .prop('hidden', false);

        // 追加結果(参加プレイヤー一覧)はページ上部にあるため、操作地点から結果へ視線を戻す
        const $selectedPlayersCard = $('#selected_players');
        if ($selectedPlayersCard.length > 0) {
          $('html, body').stop(true).animate({
            scrollTop: Math.max($selectedPlayersCard.offset().top - 16, 0)
          }, 300);
        }
      });

    renderBulkPreview();

    // 対局済みプレイヤーから選択の開閉トグル
    $('.played_players .selected_players__title')
      .off('click.togglePlayedPlayers')
      .on('click.togglePlayedPlayers', function (e) {
        if ($(e.target).closest('.popover-tooltip-container').length) return;
        const $container = $(this).closest('.played_players');
        const $playedPlayers = $container.find('#played-players');
        const $closeText = $container.find('.toggle-close');
        // クリックされた対局済みプレイヤーから選択を開閉
        $playedPlayers.slideToggle(300);
        $(this).toggleClass('active');
        if ($(this).hasClass('active')) {
          $closeText.stop(true, true).slideDown(200);
        } else {
          $closeText.stop(true, true).slideUp(200);
        }
      });

    // 初期状態に合わせて「閉じる」テキストの表示を調整
    $('.played_players').each(function () {
      const $container = $(this);
      const $title = $container.find('.selected_players__title');
      const $list = $container.find('#played-players');
      const $closeText = $container.find('.toggle-close');
      if ($list.is(':visible')) {
        $title.addClass('active');
        $closeText.show();
      } else {
        $title.removeClass('active');
        $closeText.hide();
      }
    });
  }

  // ===== 抜け番記録時の次局プレイヤー選択モーダル（matches#show / tops#show） =====
  // URLにp_ids[]を追加する
  function appendPidsToUrl(url, ids) {
    const u = new URL(url, window.location.origin);
    ids.forEach((id) => u.searchParams.append('p_ids[]', id));
    return u.toString();
  }

  // 次局選択モーダルの初期化
  function initNextPlayersSelect() {
    const $link = $('#new-match-link');
    if ($link.length === 0 || !$link.hasClass('nukeban')) return;
    $link.off('click.nextNewMatch').on('click.nextNewMatch', function (e) {
      const baseUrl = $(this).attr('href');
      if (baseUrl && baseUrl.includes('p_ids%5B%5D')) return;
      e.preventDefault();
      if (!playerSelectModal) return;
      playerSelectModal.open({
        onConfirm: function (selectedIds) {
          const url = appendPidsToUrl(baseUrl, selectedIds);
          window.location.assign(url);
        }
      });
    });
  }

  // 次局選択モーダルの初期化（抜け番対応ページのみ）
  initNextPlayersSelect();
});
